import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import DownloadIcon from '@mui/icons-material/Download';
import { IconButton } from '@mui/material';
import { SpecializedOrderStatus } from '../../api/ClientApi';
import { useAppSelector } from '../../hooks/hooks';
import { isEmployeeProcurementManager } from '../../redux/selectors/employeeSelector';

type PurchaseOrdersTableMenuProps = {
    goToPurchaseOrderForm(): void;
    goToCancelPurchaseOrderForm(): void;
    goToClosePurchaseOrderForm(): void;
    goToReceptionOrderForm(): void;
    orderStatus?: SpecializedOrderStatus;
};

export default function PurchaseOrdersTableMenu(props: PurchaseOrdersTableMenuProps) {
    const {
        goToPurchaseOrderForm,
        goToCancelPurchaseOrderForm,
        goToClosePurchaseOrderForm,
        goToReceptionOrderForm,
        orderStatus,
    } = props;

    const isProcurementManager = useAppSelector(isEmployeeProcurementManager);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const defaultDisabled =
        !orderStatus ||
        orderStatus === SpecializedOrderStatus.Cancelled ||
        orderStatus === SpecializedOrderStatus.Closed ||
        orderStatus === SpecializedOrderStatus.Delivered;
    const disabledChanging = orderStatus !== SpecializedOrderStatus.Created;
    const disabledCreatingReceptionOrder =
        orderStatus !== SpecializedOrderStatus.Created && orderStatus !== SpecializedOrderStatus.InProgress;

    return (
        <div>
            <IconButton color="primary" onClick={handleClick} sx={{ m: 0 }}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                {isProcurementManager && (
                    <MenuItem onClick={() => goToPurchaseOrderForm()} disableRipple disabled={disabledChanging}>
                        <EditIcon color="primary" />
                        Izmeni narudžbenicu
                    </MenuItem>
                )}
                {isProcurementManager && (
                    <MenuItem onClick={() => goToCancelPurchaseOrderForm()} disableRipple disabled={defaultDisabled}>
                        <CloseIcon color="error" />
                        Otkaži narudžbenicu
                    </MenuItem>
                )}
                <MenuItem
                    onClick={() => goToClosePurchaseOrderForm()}
                    disableRipple
                    disabled={defaultDisabled && orderStatus !== SpecializedOrderStatus.Delivered}
                >
                    <CheckIcon color="success" />
                    Zatvori narudžbenicu
                </MenuItem>
                <MenuItem
                    onClick={() => goToReceptionOrderForm()}
                    disableRipple
                    disabled={disabledCreatingReceptionOrder}
                >
                    <DownloadIcon color="warning" />
                    Kreiraj nalog za prijem
                </MenuItem>
            </Menu>
        </div>
    );
}
